/**
 * Orbis Sitz-Limits — TS-Spiegel von `10_Server_Config/orbis_seat_limits.js`
 * Abschnitt E: 1 Admin in der Basis. Kein Tarif-Deckel 5/10, keine Kappung 20.
 * Demo 25 nur E-Mail-Allowlist, fail-closed.
 */

export const INTERNAL_DEMO_MAX_SEATS = 25;

/** Nur diese zwei Accounts dürfen 25 Sitze — nie status-only. */
export const INTERNAL_DEMO_EMAIL_ALLOWLIST = [
  'orbis-demo@arkorbit.at',
  'thomas@arkorbit.at',
] as const;

export type OrbisSeatOpts = {
  tier?: string | null;
  includedSeats?: number | null;
  maxSeats?: number | null;
  extraSeats?: number | null;
  email?: string | null;
  status?: string | null;
  accountKind?: string | null;
  /** @deprecated Ignoriert — Demo-25 nur über E-Mail-Allowlist. */
  allowInternalDemo?: boolean;
  enterpriseUnlimited?: boolean;
};

function normalizeEmail(email?: string | null): string {
  return String(email || '')
    .trim()
    .toLowerCase();
}

function explicitSeatCount(value?: number | null): number | null {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.floor(n);
}

/** Tarif schaltet keinen Deckel frei. */
export function includedSeatsForTier(_tier?: string | null): null {
  return null;
}

/** 25 Sitze nur bei E-Mail auf der Allowlist — nie für normale Kunden / status=FIRMA_DEMO allein. */
export function isInternalDemoSeatAllowance(opts: OrbisSeatOpts = {}): boolean {
  const email = normalizeEmail(opts.email);
  if (!email) return false;
  return (INTERNAL_DEMO_EMAIL_ALLOWLIST as readonly string[]).includes(email);
}

export function resolveMaxSeats(opts: OrbisSeatOpts = {}): number | null {
  let maxSeats = explicitSeatCount(opts.maxSeats);
  if (maxSeats == null) maxSeats = explicitSeatCount(opts.includedSeats);
  if (maxSeats == null) return null;
  if (isInternalDemoSeatAllowance(opts)) {
    return Math.min(maxSeats, INTERNAL_DEMO_MAX_SEATS);
  }
  return maxSeats;
}

export function resolveSeatEntitlement(opts: OrbisSeatOpts = {}): {
  includedSeats: number | null;
  maxSeats: number | null;
} {
  const included = explicitSeatCount(opts.includedSeats);
  let maxSeats = explicitSeatCount(opts.maxSeats);
  if (maxSeats == null) maxSeats = included;
  if (isInternalDemoSeatAllowance(opts) && maxSeats != null) {
    maxSeats = Math.min(maxSeats, INTERNAL_DEMO_MAX_SEATS);
  }
  return { includedSeats: included, maxSeats };
}

/** UI-Meter: Deckel aus max_seats, Fallback included_seats. */
export function seatCeiling(
  includedSeats?: number | null,
  maxSeats?: number | null,
): number | null {
  if (typeof maxSeats === 'number' && maxSeats > 0) return maxSeats;
  if (typeof includedSeats === 'number' && includedSeats > 0) return includedSeats;
  return null;
}
